/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { Field } from 'formik'

import type { EuiRadioProps } from '@elastic/eui'
import { EuiRadio } from '@elastic/eui'

import type { FunctionComponent } from 'react'
import type { StrictOmit } from '../../ts-essentials'

interface Props extends StrictOmit<EuiRadioProps, 'onChange'> {
  // Redefine these in order to make them required
  id: string
  value: string
  className?: string
}

export const CuiFieldRadio: FunctionComponent<Props> = ({ id, name, label, value, ...rest }) => (
  <Field name={name}>
    {({ field: { onChange, onBlur, value: currentValue } }) => (
      <EuiRadio
        id={id}
        label={label}
        value={value}
        checked={value === currentValue}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
      />
    )}
  </Field>
)
